import type { StateCreator } from 'zustand'
import type { VnSessionModel } from './session'

/**
 * One-shot UI hint left behind by Open Session: lists the IFCs that
 * were loaded when the session was saved so the user can re-open them
 * from disk. Cleared explicitly by the user (dismiss button) or once
 * every saved model has been loaded back (sha256 match against the
 * viewer's current `models`).
 */
export interface SessionRestoreSlice {
  sessionRestoreModels: VnSessionModel[] | null
  setSessionRestoreModels: (models: VnSessionModel[] | null) => void
}

export const createSessionRestoreSlice: StateCreator<SessionRestoreSlice> = (
  set,
) => ({
  sessionRestoreModels: null,
  setSessionRestoreModels: (models) =>
    set({
      sessionRestoreModels: models && models.length > 0 ? models : null,
    }),
})
